module.exports = __webpack_public_path__ + "9779d9a1/img/rename-icon.de4e673d.svg";